module.exports = __webpack_public_path__ + "img/watch.234693c5.svg";